import { FC } from 'react';
import { Flex, Stack } from '@chakra-ui/react';
import { Feature } from '@shinetools/pricing-plan-library';

import { useCurrentPricingPlan } from 'common/hooks/useCurrentPricingPlan';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

import locales from './locales';

interface HeaderProps {
  onCreateItem: () => void;
}

const Header: FC<HeaderProps> = ({ onCreateItem }) => {
  const { isFeatureAvailable } = useCurrentPricingPlan();
  const isItemsCatalogAvailable = isFeatureAvailable(
    Feature.InvoicingItemsCatalog,
  );

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      marginBottom="space-40"
    >
      <Stack spacing="space-8">
        <Heading size="lg">{locales.title}</Heading>

        <Text>{locales.description}</Text>
      </Stack>

      <Button
        alignSelf="flex-start"
        icon="plus"
        iconPosition="left"
        isDisabled={!isItemsCatalogAvailable}
        onClick={onCreateItem}
        variant="primary"
      >
        {locales.add}
      </Button>
    </Flex>
  );
};

export default Header;
